// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Control } from './Control';
import InfoControlTemplate from '@front/templates/InfoControlTemplate.html';
export class InfoControl extends Control {
    getType() {
        return 'InfoControl';
    }
    constructor() {
        super();
    }
}
export class InfoData {
    constructor(id, items = []) {
        this.id = '';
        this.items = [];
        this.id = id;
        this.items = items;
    }
}
export class InfoDataItem {
    constructor(id, title = '', value = '') {
        this.id = '';
        this.title = '';
        this.value = '';
        this.id = id;
        this.title = title;
        this.value = value;
    }
}
Control.extendWith(InfoControl, {
    template: InfoControlTemplate,
    data: function () {
        return {
            data: [],
            columnsCount: 2,
            rowsCount: 2
        };
    }
});
